// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'mobile-phone-solid';

export const Component = () => (
  <path d='M7.388 2h9.962c.431 0 .766.144 1.005.383.24.239.383.526.383.862v18.103c0 .335-.143.622-.383.861-.239.24-.575.383-1.005.383H7.388c-.431 0-.766-.144-1.005-.383-.24-.239-.383-.526-.383-.861V3.245c0-.336.144-.623.383-.862.239-.24.575-.383 1.005-.383Zm9.387 1.963-1.963.048a.773.773 0 0 1-.288.623.946.946 0 0 1-.67.287h-2.97a.946.946 0 0 1-.67-.287.773.773 0 0 1-.287-.623l-1.964-.048c-.335 0-.479.144-.479.48V20.63c0 .335.144.479.48.479h8.812c.335 0 .479-.144.479-.48V4.443c0-.335-.144-.479-.48-.479Zm-3.4 13.746h-2.012c-.335 0-.479.143-.479.43v.049c0 .335.144.478.48.478h2.011c.335 0 .479-.143.479-.479v-.047c0-.288-.144-.431-.479-.431Z' />
);

export const viewBox = '0 0 25 25';
